import React from 'react';
import { VStack } from '@adc/parallax-component-library';
const IconButton = ({ children, onPress, disabled, testID, ...rest }) => {
    return (React.createElement(VStack, { testID: testID, onPress: onPress, disabled: disabled, style: { cursor: 'pointer' }, ...rest }, children));
};
export { IconButton };
